<template>
    <router-view />
</template>

<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-rentabilidade") {
            next({ name: "ven-rentabilidade-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-rentabilidade") {
            this.$router.push({ name: "ven-rentabilidade-list" });
        }
    },
};
</script>